
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import { connect } from "react-redux";
import {createSelector} from 'reselect';
import {SwarmDataMixin} from "../../../../dev/mixins/swarmDataMixin";
import Helpers from "../../../helpers/helperFunctions";
import {SetBalance, CashoutMoney} from '../../../actions/terminal';
import PropTypes from 'prop-types';
import { UIMixin } from '../../../mixins/uiMixin';

class Cashout extends Component {
    constructor (props) {
        super(props);
        this.state = {
            currency: sessionStorage.getItem("authData") && JSON.parse(sessionStorage.getItem("authData")).currency,
            balance: sessionStorage.getItem("balance") && JSON.parse(sessionStorage.getItem("balance")).session_balance
        };
        this.cashOut = this.cashOut.bind(this);
    }
    UNSAFE_componentWillReceiveProps (nextProps) {
        let terminalBalance = nextProps.terminalBalance;
        if (terminalBalance !== undefined && terminalBalance !== null) {
            this.setState((prevState) => {
                return {balance: terminalBalance || prevState.balance
                };
            });
            if (terminalBalance !== this.props.terminalBalance) {
                this.props.dispatch(SetBalance(terminalBalance));
            }
        }
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
    cashOut () {
        return () => {
            this.props.closePopup()();
            this.props.dispatch(CashoutMoney(null));
        };
    }
}
const getSwarmSubscriptionRequest = (tid) => {
    let req = {
        "source": "terminals",
        "what": {"terminals": []},
        "where": {"tid": tid}
    };
    return req;
};

const mapStateToProps = (_) => {
    return createSelector(
        [
            state => state.user.profile,
            state => state.terminal.authData,
            state => state.swarmData.data.terminal_balance &&
                Helpers.firstElement(state.swarmData.data.terminal_balance.terminals) &&
                Helpers.firstElement(state.swarmData.data.terminal_balance.terminals).balance
        ],
        (profile, authData, terminalBalance) => {
            return {
                profile,
                authData,
                terminalBalance
            };
        }
    );
};
export default connect(mapStateToProps)(UIMixin({Component: Cashout}), SwarmDataMixin(
    {
        Component: Cashout,
        ComponentWillMount: function () {
            this.swarmSubscriptionRequest = getSwarmSubscriptionRequest(this.props.authData.tid);
            this.swarmDataKey = 'terminal_balance';
            this.keepDataAfterUnsubscribe = true;
        }
    }
));
Cashout.propTypes = {
    terminalBalance: PropTypes.object,
    profile: PropTypes.object,
    authData: PropTypes.object
};